import Vue from 'vue';
import Vuex from 'vuex';
import url from './modules/url';
import {fetchNAParams} from '@baidu/map-fe-utils';
import {isBaiduMap, isIos} from '../utils';
import iframe from './modules/iframe';
import preload from './modules/preload';
import dataList from './modules/dataList';
import firstScreen from './modules/firstScreen';
import operateTask from './modules/operateTask';
import login from './modules/login';
import yy from './modules/yy';
import subscribePush from './modules/subscribePush';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        iframe,
        preload,
        dataList,
        firstScreen,
        url,
        login,
        operateTask,
        yy,
        subscribePush
    },
    state: {
        // 是否是暗黑模式
        is_dark: document.body.dataset && document.body.dataset.theme === 'dark',
        // 设备信息
        phoneInfo: {},
        cityId: 131,
        // 用户定位点坐标
        loc: '',
        stbarHeight: 20,
        currentIndex: 0,
        // 下载弹窗显示状态
        downloadShowFlag: false,
        firstLowImg: '',
        hasBase64: false,
        // 是否显示loading提示
        showLoading: false
    },
    getters: {
        is_dark: state => state.is_dark,
        phoneInfo: state => state.phoneInfo,
        cityId: state => state.cityId,
        loc: state => state.loc,
        currentIndex: state => state.currentIndex,
        sv: state => state.sv,
        fixedTab: state => state.fixedTab,
        isNative: state => state.isNative,
        stbarHeight: state => state.stbarHeight,
        downloadShowFlag: state => state.downloadShowFlag,
        firstLowImg: state => state.firstLowImg,
        hasBase64: state => state.hasBase64,
        showLoading: state => state.showLoading
    },
    mutations: {
        setPhoneInfo(state, params) {
            const {loc} = params;
            state.phoneInfo = params;
            state.cityId = Number(params.c) || 131;
            state.loc = loc || '';

        },
        setStBarHeight(state, params) {
            const {url_stbar_height, stbar_height} = params;
            // 如果url 参数中包含状态栏高度，直接使用url参数中的
            if (url_stbar_height) {
                state.stbarHeight = +url_stbar_height || 20;
            }
            else {
                if (isIos()) {
                    state.stbarHeight = +stbar_height || 20;
                }
                else {
                    state.stbarHeight = +stbar_height ? (+stbar_height / (window.devicePixelRatio || 2)) : 20;
                }
            }

            // 如果在端内，设置stbarHeight高度
            if (isBaiduMap()) {
                let root = document.documentElement;
                root.style.setProperty('--stbar-height', Math.ceil(state.stbarHeight + 1) + 'px');
            }

        },
        // 更新当前笔记索引
        setFeedIndex(state, index) {
            state.currentIndex = index;
        },
        setDownloadShowFlag(state, flag) {
            state.downloadShowFlag = flag;
        },
        setFirstLowImg(state, img) {
            state.firstLowImg = img;
        },
        setHasBase64(state, flag) {
            state.hasBase64 = flag;
        },
        // 设置暗黑模式状态
        setIsDark(state, flag) {
            state.is_dark = flag;
        },
        setShowLoading(state, flag) {
            state.showLoading = flag;
        }
    },
    actions: {
        async fetchPhoneInfo({commit, state}, preloadPhoneInfo) {
            const {stbar_height} = state.url.urlParams || {};

            let params = await fetchNAParams();

            if (preloadPhoneInfo) {
                params = {...params, ...preloadPhoneInfo};
            }
            if (stbar_height) {
                params.url_stbar_height = stbar_height;
            }
            if (Object.keys(params).length > 0) { // 确保不是空对象
                if ('preloadInfo' in params) {
                    const {preloadInfo, ...restParams} = params;
                    params = restParams;
                }

                // 二级容器组件包，取params.phoneinfo字段替换params
                if (params.container === 'lgui' && params.phoneinfo) {
                    params = params.phoneinfo;
                }

                commit('setPhoneInfo', params);
                commit('setStBarHeight', params);
            }
        }
    }
});
